import { getCreatedPromotionsAPI } from "./api";

export function getCreatedPromotions(data) {
  return new Promise((resolve, reject) => {
    getCreatedPromotionsAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}
